module.exports = __webpack_public_path__ + "img/7P.34ae889c.png";